import React, { FC } from 'react';
import {
  ProductiveHeading01,
  ProductiveHeading02,
  ProductiveHeading03,
  ProductiveHeading04,
  ProductiveHeading05,
  ProductiveHeading06,
  ProductiveHeading07,
} from 'ozone/atoms';
import { SubHeading2 } from './components';
import { TypeToken } from './type-token';

export const HeadingStyles: FC = () => (
  <>
    <SubHeading2>Body styles</SubHeading2>
    <TypeToken component={ProductiveHeading01}>
      This is for component and layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading02}>
      This is for component and layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading03}>
      This is for component and layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading04}>
      This is for layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading05}>
      This is for layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading06}>
      This is for layout headings.
    </TypeToken>
    <TypeToken component={ProductiveHeading07}>
      This is for layout headings.
    </TypeToken>
  </>
);
